var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.record && _vm.record.link)?[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":'https://'+_vm.record.link+'.'+_vm.record.domain+'/'+_vm.url,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" Portal Link")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }